import { Box, Button } from "@material-ui/core";
import { get } from "lodash";
import React from "react";
import { checkArrayLength } from "../../../../utils";

const TargetObjectives = colProps => {
  return (
    <td className="truncate-txt">
      <Box display={"flex"} alignItems="center" justifyContent="center">
        <Button
          onClick={() => {
            colProps.setShowObjectivesModal({
              showModal: true,
              data: get(colProps, "dataItem.targetObjective.items", []),
              target: get(colProps, "dataItem", [])
            });
          }}>
          {checkArrayLength(colProps.dataItem.objectives)}
        </Button>
      </Box>
    </td>
  );
};

export default TargetObjectives;
